import {
  DateRange,
  DateRangePicker as MuiDateRangePicker,
  LocalizationProvider,
  DateRangePickerProps as MuiDateRangePickerProps,
  PickersShortcutsItem,
} from '@mui/x-date-pickers-pro'
import { AdapterLuxon } from '@mui/x-date-pickers-pro/AdapterLuxon'
import { DateTime } from 'luxon'
import { FC } from 'react'

type Props = {
  startText?: string
  endText?: string
  onChange?: (value: DateRange<DateTime>) => void
  value: DateRange<DateTime>
  shortcutsItems?: PickersShortcutsItem<DateRange<DateTime>>[]
  singleInput?: boolean
} & Omit<MuiDateRangePickerProps, 'value' | 'onChange'>

export const DateRangePicker: FC<Props> = ({ startText, endText, onChange, value, ...otherProps }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="ja">
      <MuiDateRangePicker
        localeText={{
          start: startText,
          end: endText,
        }}
        value={value}
        onChange={onChange}
        {...otherProps}
      />
    </LocalizationProvider>
  )
}
